import { useParams } from "@tanstack/react-router";
import { Empty, Flex, Spin, Typography } from "antd";

import { RoomView, useAPI } from "@neu/libui";

import styles from "./PatientCommunication.module.scss";

type PatientChatRoomResponse = {
	status: "ready" | "no_portal_user" | "no_room";
	roomID?: number;
	patientUserID?: number;
};

export const PatientCommunication = () => {
	const { patientID } = useParams({ strict: false });
	const [{ data, isLoading, error }] = useAPI<PatientChatRoomResponse>(
		patientID ? `/patient/chat-room?id=${patientID}` : null
	);

	return (
		<Flex vertical flex={1} className={styles.communication}>
			{(isLoading || !patientID) && (
				<Flex flex={1} align="center" justify="center">
					<Spin size="large" />
				</Flex>
			)}

			{!isLoading && patientID && error && (
				<Flex flex={1} align="center" justify="center">
					<Empty description="Unable to load communication" />
				</Flex>
			)}

			{!isLoading && patientID && !error && data?.status === "no_portal_user" && (
				<Flex flex={1} align="center" justify="center">
					<Empty
						description={
							<Typography.Text type="secondary">
								This patient does not have a portal account linked yet.
							</Typography.Text>
						}
					/>
				</Flex>
			)}

			{!isLoading && patientID && !error && data?.status === "no_room" && (
				<Flex flex={1} align="center" justify="center">
					<Empty
						description={
							<Typography.Text type="secondary">
								No care team chat room is available for this patient yet.
							</Typography.Text>
						}
					/>
				</Flex>
			)}

			{!isLoading &&
				patientID &&
				!error &&
				data?.status === "ready" &&
				data.roomID != null && (
					<RoomView roomID={String(data.roomID)} />
				)}
		</Flex>
	);
};
